import { createReducer, on } from '@ngrx/store';

import { resizeview, updateOrientation } from '../actions';

export interface ResizeViewState {
    height: number;
    width: number;
    orientation?: string;
}

export const initialState: ResizeViewState = {
    height: window.innerHeight,
    width: window.innerWidth,
    orientation: window.matchMedia('(orientation: portrait)').matches ?
        'portrait' : window.matchMedia('(orientation: landscape)') ? 'landscape' : ''
};

const _resizeViewReducer = createReducer(initialState,

    on(resizeview, (state, params) => ({
        ...state
        , height: params.height
        , width: params.width
    })),
    on(updateOrientation, state => ({
        ...state,
        orientation: window.matchMedia('(orientation: portrait)').matches ?
            'portrait' : window.matchMedia('(orientation: landscape)')
                ? 'landscape' : ''
    })),

);

export function resizeViewReducer(state: any, action: any) {
    return _resizeViewReducer(state, action);
}
